import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Icon } from '@iconify/vue';
import { computed } from 'vue';
interface Props {
  row?: boolean;
  small?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    row: { type: Boolean },
    small: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { row?: boolean, small: boolean }



const iconWidth = computed(() => {
  if (props.small) return '24px';
  return props.row ? '36px' : '48px';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-gray-300", { 'flex items-center space-x-4': __props.row, 'space-y-4': !__props.row }])
  }, [
    _createVNode(_unref(Icon), {
      class: "mx-auto",
      icon: "entypo:tree",
      width: _unref(iconWidth)
    }, null, 8, ["width"]),
    _createElementVNode("h1", {
      class: _normalizeClass(["font-medium", __props.small ? 'text-xl' : 'text-2xl'])
    }, " Coming soon ", 2)
  ], 2))
}
}

})